import React from 'react';

import Paragraph from 'pages/Landings/components/Paragraph';

import useStyles from './styles';

interface Props {
    title: React.ReactNode;
    icon: React.ReactNode;
    description?: React.ReactNode;
    className?: string;
}

const Card: React.FC<Props> = ({ title, icon, description, className }) => {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.root, className)}>
            <span className={classes.icon}>{icon}</span>
            <Paragraph primary={title} secondary={description} />
        </div>
    );
};

export default Card;
